var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoinBig(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 59,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M49.719 6.015c6.198 5.242 3.892 18.95-5.234 30.633C35.358 48.332 22.9 53.644 16.754 48.535c.102.265 4.693 3.953 4.871 4.042 6.199 5.242 18.656-.07 27.731-11.886C58.483 29.008 60.79 15.3 54.591 10.058c-.103-.265-4.694-3.954-4.872-4.043Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M53.95 9.492c6.199 5.243 3.892 18.956-5.236 30.643-9.129 11.687-21.59 17-27.738 11.89 0 0-1.862-1.467-3.19-2.666 1.455 1.155 3.776 3.066 3.828 3.199 6.2 5.243 18.66-.07 27.738-11.89 9.128-11.687 11.435-25.4 5.235-30.642-.052-.133-2.551-2.134-3.879-3.333 1.328 1.2 3.011 2.577 3.19 2.667l.051.132Z",
    opacity: 0.5,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M44.535 36.77c-9.138 11.704-21.612 17.025-27.767 11.907.46.444.817.623.868.756 6.207 5.25 18.68-.07 27.768-11.906 9.138-11.704 11.447-25.435 5.24-30.686 0 0-.408-.311-.868-.756 6.207 5.25 3.898 18.982-5.24 30.686Z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M49.435 6.294c6.24 5.357 4.143 19.135-4.768 30.79-8.911 11.654-21.227 16.85-27.416 11.627-6.24-5.356-4.143-19.134 4.768-30.789C30.931 6.267 43.247 1.072 49.435 6.294Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M49.31 6.342C55.552 11.699 53.4 25.344 44.489 37 35.577 48.657 23.385 53.81 17.07 48.63c-6.242-5.357-4.09-19.003 4.822-30.66C30.803 6.316 42.995 1.162 49.31 6.343Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M49.359 6.469c6.188 5.222 4.09 19-4.695 30.61-8.91 11.655-21.1 16.807-27.289 11.586-6.188-5.222-4.09-19 4.695-30.611C30.981 6.4 43.171 1.247 49.36 6.469Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M49.234 6.516c6.188 5.222 4.038 18.866-4.748 30.478-8.785 11.612-20.975 16.765-27.163 11.543-6.188-5.222-4.038-18.866 4.748-30.478C30.856 6.447 43.046 1.294 49.234 6.516Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M49.234 6.516c6.188 5.222 4.038 18.866-4.748 30.478-8.785 11.612-20.975 16.765-27.163 11.543-6.188-5.222-4.038-18.866 4.748-30.478C30.856 6.447 43.046 1.294 49.234 6.516Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M49.16 6.686c6.188 5.222 4.037 18.868-4.676 30.305-8.84 11.48-20.906 16.591-27.042 11.503-6.188-5.223-4.038-18.868 4.676-30.306 8.84-11.48 20.906-16.59 27.095-11.368l-.053-.134Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M49.168 6.691c6.188 5.223 3.985 18.733-4.729 30.17-8.713 11.437-20.779 16.548-26.967 11.325-6.188-5.222-4.11-18.69 4.729-30.17C30.914 6.58 42.98 1.47 49.168 6.692Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M49.04 6.737c6.187 5.222 4.11 18.688-4.603 30.122C35.725 48.294 23.661 53.404 17.6 48.141c-6.188-5.222-4.11-18.688 4.602-30.122C30.914 6.584 42.978 1.474 49.04 6.737Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M49.091 6.866c6.136 5.088 4.057 18.555-4.656 29.991-8.713 11.436-20.652 16.505-26.84 11.283-6.135-5.088-4.057-18.556 4.656-29.992C30.964 6.712 42.903 1.644 49.091 6.866Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M48.962 6.912C55.097 12 53.02 25.466 44.307 36.901 35.72 48.294 23.782 53.36 17.594 48.14c-6.135-5.088-4.057-18.554 4.656-29.99C30.836 6.76 42.775 1.692 48.962 6.913Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M48.97 6.911c6.008 5.13 4.003 18.419-4.583 29.811C35.8 48.115 23.809 53.048 17.8 47.92c-6.008-5.129-4.003-18.418 4.583-29.811C30.97 6.716 42.961 1.782 48.97 6.911Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M48.893 7.085c6.01 5.13 4.004 18.422-4.637 29.683-8.641 11.26-20.456 16.288-26.591 11.2-6.01-5.131-4.004-18.424 4.637-29.684 8.64-11.26 20.455-16.288 26.59-11.2Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M48.764 7.131c6.009 5.13 4.003 18.421-4.637 29.68-8.515 11.218-20.454 16.287-26.463 11.157-6.01-5.13-4.004-18.421 4.636-29.68C30.815 7.07 42.754 2 48.763 7.13Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M48.77 7.131c6.008 5.13 3.95 18.285-4.564 29.502C35.69 47.85 23.879 52.876 17.869 47.746c-6.008-5.13-3.95-18.285 4.564-29.502C30.947 7.028 42.76 2.001 48.769 7.131Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M48.692 7.306c6.01 5.13 3.951 18.286-4.617 29.369-8.514 11.217-20.202 16.2-26.21 11.071-6.01-5.13-3.952-18.286 4.616-29.369C30.995 7.16 42.683 2.177 48.692 7.306Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M48.695 7.303c5.956 4.995 3.898 18.152-4.491 29.327-8.515 11.217-20.255 16.067-26.212 11.072-5.956-4.996-3.898-18.152 4.491-29.328C30.998 7.157 42.74 2.307 48.695 7.303Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M48.571 7.35c5.957 4.995 3.899 18.153-4.544 29.195-8.443 11.042-20.132 16.027-26.089 11.031-5.956-4.996-3.898-18.154 4.545-29.196C30.926 7.338 42.615 2.353 48.57 7.35Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M48.62 7.476c5.956 4.996 3.844 18.018-4.545 29.193-8.442 11.041-20.004 15.983-25.96 10.988-5.957-4.996-3.846-18.018 4.544-29.194C31.1 7.423 42.663 2.48 48.618 7.476Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M48.495 7.522c5.956 4.996 3.845 18.017-4.471 29.016C35.582 47.578 24.02 52.52 18.19 47.482c-5.956-4.995-3.845-18.017 4.471-29.015C31.103 7.427 42.665 2.485 48.495 7.522Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M48.5 7.523c5.957 4.996 3.845 18.02-4.525 28.885-8.317 11-19.88 15.942-25.837 10.946-5.956-4.996-3.97-17.977 4.525-28.885C30.98 7.47 42.543 2.527 48.5 7.523Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M48.42 7.695c5.83 5.038 3.917 17.84-4.398 28.839-8.316 10.998-19.93 15.805-25.708 10.902-5.83-5.037-3.918-17.84 4.398-28.838C31.028 7.6 42.642 2.792 48.42 7.695Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M48.296 7.743c5.777 4.903 3.917 17.84-4.452 28.705-8.316 10.998-19.806 15.764-25.583 10.86-5.777-4.903-3.917-17.84 4.452-28.705C31.029 7.605 42.518 2.84 48.296 7.743Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M48.297 7.742c5.777 4.904 3.864 17.708-4.453 28.707C35.6 47.272 24.164 52.173 18.26 47.311c-5.778-4.904-3.865-17.708 4.452-28.708C30.956 7.781 42.392 2.88 48.297 7.742Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "M48.22 7.916c5.778 4.903 3.865 17.707-4.379 28.529s-19.68 15.722-25.457 10.819c-5.778-4.904-3.865-17.708 4.379-28.53C31.006 7.912 42.443 3.012 48.22 7.916Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M48.226 7.916c5.778 4.903 3.811 17.573-4.433 28.396-8.243 10.822-19.555 15.68-25.332 10.777-5.778-4.904-3.812-17.574 4.432-28.396C31.137 7.87 42.448 3.013 48.226 7.916Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M48.098 7.96c5.778 4.903 3.811 17.573-4.433 28.396S24.182 51.86 18.457 47.09c-5.777-4.904-3.811-17.574 4.433-28.397C31.134 7.871 42.373 3.19 48.15 8.094l-.052-.135Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M48.153 8.093c5.777 4.903 3.758 17.438-4.36 28.218-8.118 10.78-19.482 15.504-25.26 10.6-5.777-4.903-3.758-17.438 4.36-28.218 8.118-10.78 19.482-15.503 25.26-10.6Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "M48.153 8.093c5.777 4.903 3.758 17.438-4.36 28.218-8.118 10.78-19.482 15.504-25.26 10.6-5.777-4.903-3.758-17.438 4.36-28.218 8.118-10.78 19.482-15.503 25.26-10.6Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "M48.023 8.14c5.777 4.902 3.758 17.436-4.359 28.215s-19.48 15.502-25.131 10.557c-5.777-4.903-3.758-17.437 4.359-28.215C31.009 7.917 42.372 3.194 48.023 8.14Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "M48.023 8.14c5.777 4.902 3.758 17.436-4.359 28.215S24.31 51.815 18.533 46.912c-5.777-4.903-3.758-17.437 4.359-28.215C31.009 7.917 42.246 3.236 48.023 8.14Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#G)",
    d: "M48.025 8.139c5.724 4.769 3.758 17.438-4.36 28.217-8.17 10.646-19.355 15.461-25.133 10.558-5.724-4.769-3.758-17.438 4.36-28.218C31.062 8.051 42.248 3.236 48.025 8.14Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#H)",
    d: "M48.03 8.139c5.725 4.77 3.758 17.44-4.413 28.087-8.172 10.647-19.358 15.464-25.136 10.56-5.726-4.77-3.76-17.44 4.413-28.088C31.066 8.051 42.252 3.235 48.03 8.14Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#I)",
    d: "M48.03 8.139c5.725 4.77 3.758 17.44-4.413 28.087-8.172 10.647-19.358 15.464-25.136 10.56-5.726-4.77-3.76-17.44 4.413-28.088C31.066 8.051 42.252 3.235 48.03 8.14Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#J)",
    d: "M48.03 8.139c5.725 4.77 3.758 17.44-4.413 28.087-8.172 10.647-19.358 15.464-25.136 10.56-5.726-4.77-3.76-17.44 4.413-28.088C31.066 8.051 42.252 3.235 48.03 8.14Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#K)",
    d: "M48.03 8.139c5.725 4.769 3.759 17.438-4.412 28.084S24.26 51.685 18.609 46.74c-5.724-4.769-3.758-17.438 4.413-28.084S42.38 3.193 48.031 8.139Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#L)",
    d: "M48.032 8.138c5.724 4.769 3.758 17.437-4.287 28.04-8.17 10.645-19.355 15.46-25.006 10.515-5.725-4.769-3.759-17.437 4.286-28.04C31.195 8.008 42.38 3.193 48.032 8.138Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#M)",
    d: "M47.901 8.185c5.724 4.769 3.758 17.437-4.286 28.04-8.17 10.645-19.23 15.417-25.007 10.515-5.724-4.77-3.758-17.437 4.287-28.04 8.17-10.645 19.23-15.418 25.006-10.515Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#N)",
    d: "M47.948 8.313c5.724 4.768 3.705 17.302-4.287 28.04-8.044 10.602-19.229 15.417-25.006 10.514-5.724-4.768-3.705-17.302 4.287-28.04C30.987 8.226 42.172 3.41 47.948 8.314Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#O)",
    d: "M47.953 8.313c5.725 4.77 3.705 17.306-4.34 27.91-8.046 10.604-19.232 15.42-25.01 10.516-5.724-4.77-3.705-17.305 4.34-27.91C30.99 8.227 42.176 3.41 47.954 8.314Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#P)",
    d: "M47.955 8.311c5.725 4.77 3.706 17.307-4.34 27.913C35.567 46.829 24.327 51.51 18.602 46.74c-5.726-4.77-3.706-17.307 4.34-27.912C30.99 8.223 42.23 3.54 47.956 8.31Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Q)",
    d: "M47.955 8.311c5.725 4.77 3.705 17.305-4.34 27.91C35.569 46.825 24.33 51.505 18.73 46.695c-5.725-4.77-3.706-17.305 4.34-27.91C31.117 8.181 42.356 3.5 47.955 8.311Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#R)",
    d: "M47.955 8.311c5.725 4.77 3.705 17.305-4.34 27.91C35.569 46.825 24.33 51.505 18.73 46.695c-5.725-4.77-3.706-17.305 4.34-27.91C31.117 8.181 42.356 3.5 47.955 8.311Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#S)",
    d: "M47.955 8.311c5.725 4.77 3.705 17.305-4.34 27.91C35.569 46.825 24.33 51.505 18.73 46.695c-5.725-4.77-3.706-17.305 4.34-27.91C31.117 8.181 42.356 3.5 47.955 8.311Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#T)",
    d: "M47.955 8.311c5.725 4.77 3.705 17.305-4.34 27.91-8.046 10.604-19.16 15.243-24.884 10.474-5.725-4.77-3.706-17.305 4.34-27.91C31.117 8.181 42.231 3.542 47.955 8.311Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#U)",
    d: "M47.826 8.358c5.724 4.77 3.705 17.305-4.34 27.91C35.44 46.87 24.325 51.51 18.601 46.74c-5.725-4.769-3.706-17.305 4.34-27.909S42.101 3.588 47.826 8.358Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#V)",
    d: "M47.83 8.358c5.726 4.77 3.706 17.308-4.393 27.78C35.39 46.742 24.276 51.382 18.55 46.612c-5.725-4.77-3.706-17.307 4.394-27.779C30.991 8.23 42.105 3.588 47.831 8.358Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#W)",
    d: "M47.831 8.359c5.599 4.81 3.705 17.303-4.267 27.729-8.045 10.603-19.157 15.242-24.755 10.43-5.599-4.81-3.705-17.302 4.267-27.728C31.121 8.187 42.233 3.548 47.831 8.359Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#X)",
    d: "M47.831 8.359c5.599 4.81 3.652 17.168-4.267 27.729-8.045 10.603-19.157 15.242-24.755 10.43-5.599-4.81-3.652-17.168 4.267-27.728C31.121 8.187 42.233 3.548 47.831 8.359Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Y)",
    d: "M47.831 8.359c5.599 4.81 3.652 17.168-4.267 27.729-8.045 10.603-19.157 15.242-24.755 10.43-5.599-4.81-3.652-17.168 4.267-27.728C31.121 8.187 42.233 3.548 47.831 8.359Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Z)",
    d: "M47.831 8.359c5.599 4.81 3.652 17.168-4.267 27.729-8.045 10.603-19.157 15.242-24.755 10.43-5.599-4.81-3.652-17.168 4.267-27.728C31.121 8.187 42.233 3.548 47.831 8.359Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aa)",
    d: "M47.831 8.359c5.599 4.81 3.652 17.168-4.267 27.729-8.045 10.603-19.031 15.2-24.755 10.43-5.599-4.81-3.652-17.168 4.267-27.728C31.121 8.187 42.107 3.59 47.831 8.359Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ab)",
    d: "M47.878 8.487c5.598 4.81 3.652 17.168-4.267 27.729-8.045 10.603-19.031 15.2-24.756 10.43-5.598-4.81-3.652-17.168 4.268-27.728 8.044-10.603 19.03-15.2 24.755-10.431Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ac)",
    d: "M47.753 8.534c5.599 4.81 3.652 17.169-4.32 27.596-7.92 10.56-19.032 15.2-24.63 10.389-5.599-4.811-3.652-17.17 4.32-27.596 7.92-10.561 19.032-15.2 24.63-10.389Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ad)",
    d: "M47.755 8.532c5.599 4.811 3.778 17.128-4.32 27.598C35.46 46.558 24.4 51.332 18.801 46.52c-5.6-4.811-3.778-17.128 4.32-27.598C31.096 8.494 42.156 3.72 47.755 8.532Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ae)",
    d: "M47.755 8.532c5.599 4.811 3.778 17.128-4.32 27.598C35.46 46.558 24.4 51.332 18.801 46.52c-5.6-4.811-3.778-17.128 4.32-27.598C31.096 8.494 42.156 3.72 47.755 8.532Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#af)",
    d: "M47.755 8.532c5.599 4.811 3.778 17.128-4.32 27.598C35.46 46.558 24.4 51.332 18.801 46.52c-5.6-4.811-3.778-17.128 4.32-27.598C31.096 8.494 42.156 3.72 47.755 8.532Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ag)",
    d: "M47.755 8.532c5.599 4.811 3.725 16.994-4.32 27.598-7.974 10.428-18.909 15.16-24.633 10.39-5.6-4.811-3.725-16.994 4.32-27.598C31.096 8.494 42.03 3.762 47.755 8.532Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ah)",
    d: "M47.757 8.53c5.545 4.677 3.724 16.992-4.195 27.552-7.971 10.425-18.904 15.156-24.502 10.345-5.545-4.676-3.724-16.99 4.194-27.55C31.226 8.45 42.16 3.72 47.757 8.53Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ai)",
    d: "M47.762 8.532c5.545 4.677 3.724 16.993-4.248 27.42C35.54 46.379 24.607 51.11 19.008 46.299c-5.545-4.677-3.724-16.993 4.248-27.42C31.23 8.452 42.163 3.72 47.762 8.532Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aj)",
    d: "M47.632 8.576c5.546 4.678 3.725 16.996-4.248 27.424-7.974 10.428-18.962 15.026-24.508 10.348-5.547-4.677-3.725-16.995 4.248-27.423C31.098 8.497 42.086 3.899 47.632 8.576Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ak)",
    d: "M47.632 8.576c5.546 4.678 3.725 16.996-4.248 27.424-7.974 10.428-18.962 15.026-24.508 10.348-5.547-4.677-3.725-16.995 4.248-27.423C31.098 8.497 42.086 3.899 47.632 8.576Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#al)",
    d: "M47.68 8.704c5.546 4.677 3.725 16.995-4.248 27.423-7.974 10.429-18.836 14.984-24.508 10.349-5.546-4.678-3.725-16.995 4.248-27.424C31.146 8.624 42.008 4.07 47.68 8.704Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#am)",
    d: "M47.68 8.703c5.547 4.677 3.726 16.994-4.247 27.421s-18.834 14.982-24.38 10.305c-5.546-4.677-3.725-16.993 4.248-27.42C31.274 8.58 42.135 4.026 47.681 8.703Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#an)",
    d: "M47.687 8.71c5.546 4.677 3.725 16.993-4.3 27.286-7.848 10.385-18.835 14.982-24.38 10.305-5.547-4.676-3.726-16.993 4.247-27.42C31.102 8.496 42.088 3.899 47.634 8.576l.053.134Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ao)",
    d: "M47.686 8.704c5.546 4.678 3.672 16.862-4.302 27.29-7.848 10.387-18.836 14.984-24.383 10.307-5.546-4.678-3.672-16.862 4.302-27.29C31.15 8.624 42.139 4.026 47.686 8.704Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ap)",
    d: "M47.556 8.751c5.546 4.678 3.672 16.862-4.302 27.29-7.848 10.387-18.836 14.985-24.383 10.307-5.546-4.678-3.672-16.861 4.302-27.29C31.02 8.67 42.009 4.074 47.556 8.75Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aq)",
    d: "M47.557 8.75c5.546 4.677 3.672 16.858-4.175 27.243-7.846 10.384-18.707 14.939-24.252 10.262-5.546-4.677-3.672-16.858 4.175-27.242C31.15 8.628 42.138 4.032 47.557 8.75Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ar)",
    d: "M47.557 8.75c5.546 4.677 3.672 16.858-4.175 27.243-7.846 10.384-18.707 14.939-24.252 10.262-5.546-4.677-3.672-16.858 4.175-27.242C31.15 8.628 42.012 4.073 47.557 8.75Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#as)",
    d: "M47.557 8.75c5.546 4.677 3.672 16.858-4.175 27.243-7.846 10.384-18.707 14.939-24.252 10.262-5.546-4.677-3.672-16.858 4.175-27.242C31.15 8.628 42.012 4.073 47.557 8.75Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#at)",
    d: "M47.562 8.75c5.546 4.678 3.672 16.861-4.228 27.113-7.848 10.386-18.71 14.94-24.256 10.264-5.546-4.678-3.672-16.86 4.229-27.112C31.154 8.629 42.016 4.074 47.561 8.75Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#au)",
    d: "M47.562 8.75c5.546 4.678 3.672 16.861-4.228 27.113-7.848 10.386-18.71 14.94-24.256 10.264-5.546-4.678-3.672-16.86 4.229-27.112C31.154 8.629 42.016 4.074 47.561 8.75Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#av)",
    d: "M47.48 8.925c5.545 4.677 3.671 16.859-4.229 27.11-7.847 10.384-18.707 14.939-24.128 10.22-5.545-4.677-3.671-16.859 4.229-27.109C31.199 8.761 42.06 4.206 47.48 8.926Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aw)",
    d: "M47.481 8.924c5.546 4.677 3.62 16.726-4.228 27.111-7.901 10.252-18.584 14.899-24.13 10.222-5.546-4.677-3.62-16.726 4.228-27.112 7.9-10.251 18.584-14.898 24.13-10.221Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ax)",
    d: "M47.481 8.924c5.546 4.677 3.62 16.726-4.228 27.111-7.901 10.252-18.584 14.899-24.13 10.222-5.546-4.677-3.62-16.726 4.228-27.112 7.9-10.251 18.584-14.898 24.13-10.221Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ay)",
    d: "M47.482 8.923c5.546 4.677 3.619 16.724-4.103 27.067-7.774 10.208-18.582 14.897-24.127 10.22-5.546-4.677-3.619-16.724 4.102-27.067C31.13 8.935 41.936 4.246 47.482 8.923Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#az)",
    d: "M47.488 8.921c5.547 4.678 3.62 16.728-4.157 26.94-7.776 10.21-18.639 14.766-24.133 10.222-5.546-4.677-3.619-16.728 4.157-26.939 7.776-10.21 18.64-14.767 24.133-10.223Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aA)",
    d: "M47.49 8.92c5.546 4.678 3.618 16.727-4.157 26.937s-18.637 14.765-24.005 10.18c-5.546-4.678-3.62-16.727 4.156-26.937C31.26 8.89 42.122 4.335 47.49 8.92Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aB)",
    d: "M47.359 8.968c5.546 4.677 3.619 16.726-4.157 26.936-7.775 10.21-18.511 14.723-24.005 10.18-5.546-4.678-3.619-16.727 4.157-26.937 7.775-10.21 18.511-14.723 24.005-10.18Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aC)",
    d: "M47.359 8.968c5.546 4.677 3.619 16.726-4.157 26.936-7.775 10.21-18.511 14.723-24.005 10.18-5.546-4.678-3.619-16.727 4.157-26.937 7.775-10.21 18.511-14.723 24.005-10.18Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aD)",
    d: "M47.365 8.968c5.493 4.543 3.566 16.593-4.21 26.803-7.775 10.21-18.512 14.723-23.88 10.138-5.493-4.544-3.566-16.593 4.21-26.803C31.26 8.895 41.997 4.381 47.365 8.967Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aE)",
    d: "M47.411 9.096c5.494 4.543 3.567 16.593-4.209 26.803-7.775 10.21-18.387 14.681-23.88 10.138-5.493-4.543-3.566-16.593 4.21-26.803 7.775-10.21 18.386-14.682 23.88-10.138Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aF)",
    d: "M47.282 9.144c5.367 4.585 3.565 16.59-4.083 26.756-7.775 10.208-18.384 14.679-23.877 10.136-5.367-4.584-3.565-16.59 4.083-26.756C31.18 9.072 41.79 4.602 47.282 9.144Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aG)",
    d: "M47.288 9.144c5.367 4.585 3.566 16.59-4.136 26.623C35.502 45.933 24.767 50.446 19.4 45.86c-5.367-4.585-3.566-16.59 4.136-26.622 7.65-10.167 18.385-14.68 23.752-10.095Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aH)",
    d: "M47.288 9.144C52.655 13.73 50.8 25.6 43.152 35.767 35.502 45.933 24.892 50.404 19.4 45.86c-5.367-4.585-3.513-16.456 4.136-26.622C31.186 9.071 41.796 4.6 47.288 9.143Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aI)",
    d: "M47.164 9.19c5.368 4.585 3.513 16.458-4.19 26.491-7.702 10.034-18.26 14.64-23.628 10.054-5.368-4.585-3.513-16.458 4.19-26.492C31.238 9.21 41.796 4.604 47.164 9.19Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aJ)",
    d: "M47.213 9.314c5.368 4.586 3.513 16.459-4.064 26.45C35.446 45.798 24.835 50.27 19.52 45.818c-5.367-4.585-3.513-16.459 4.064-26.45C31.287 9.334 41.898 4.863 47.215 9.314Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aK)",
    d: "M47.084 9.36c5.367 4.586 3.46 16.323-4.064 26.448-7.702 10.032-18.186 14.461-23.5 10.01-5.368-4.584-3.46-16.322 4.063-26.447C31.285 9.34 41.77 4.911 47.084 9.361Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aL)",
    d: "M47.091 9.366c5.368 4.585 3.586 16.282-4.117 26.315-7.577 9.99-18.188 14.462-23.555 9.877-5.368-4.586-3.586-16.282 4.117-26.315C31.113 9.252 41.723 4.781 47.09 9.366Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aM)",
    d: "M47.091 9.365c5.368 4.585 3.586 16.28-4.116 26.312-7.576 9.99-18.06 14.419-23.428 9.834-5.367-4.585-3.585-16.28 4.117-26.312C31.24 9.21 41.724 4.781 47.09 9.365Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aN)",
    d: "M47.01 9.54c5.313 4.45 3.584 16.278-3.991 26.267-7.576 9.988-18.059 14.416-23.426 9.832-5.313-4.45-3.584-16.278 3.991-26.267C31.16 9.383 41.643 4.956 47.01 9.54Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aO)",
    d: "M47.016 9.54c5.313 4.45 3.532 16.145-4.044 26.134s-18.06 14.417-23.3 9.79c-5.314-4.45-3.533-16.144 4.043-26.133 7.576-9.99 18.06-14.417 23.3-9.79Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aP)",
    d: "M47.016 9.54c5.313 4.45 3.532 16.145-4.044 26.134s-17.934 14.375-23.3 9.79c-5.314-4.45-3.533-16.144 4.043-26.133 7.576-9.99 17.934-14.375 23.3-9.79Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aQ)",
    d: "M46.891 9.585c5.315 4.452 3.533 16.15-4.097 26.007-7.452 9.95-17.991 14.245-23.306 9.793-5.315-4.451-3.533-16.148 4.098-26.006 7.451-9.95 17.99-14.245 23.305-9.794Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aR)",
    d: "M46.895 9.584c5.314 4.45 3.533 16.146-3.972 25.96-7.504 9.815-17.863 14.201-23.177 9.75-5.315-4.45-3.533-16.146 3.971-25.96 7.505-9.815 17.864-14.201 23.178-9.75Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aS)",
    d: "M46.942 9.712c5.314 4.45 3.48 16.012-3.972 25.96-7.504 9.815-17.863 14.201-23.178 9.75-5.314-4.45-3.479-16.012 3.972-25.96 7.504-9.815 17.863-14.201 23.178-9.75Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aT)",
    d: "M46.817 9.758c5.315 4.452 3.48 16.014-4.025 25.828-7.504 9.815-17.863 14.202-23.052 9.708-5.315-4.45-3.48-16.013 4.025-25.827 7.504-9.815 17.863-14.202 23.052-9.709Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aU)",
    d: "M46.817 9.758c5.315 4.452 3.48 16.014-4.025 25.828-7.504 9.815-17.738 14.16-23.052 9.708-5.315-4.45-3.48-16.013 4.025-25.827 7.504-9.815 17.738-14.16 23.052-9.709Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aV)",
    d: "M46.824 9.758c5.314 4.45 3.426 15.877-3.952 25.65-7.378 9.77-17.737 14.157-22.926 9.664-5.314-4.45-3.426-15.877 3.952-25.649S41.635 5.265 46.824 9.758Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aW)",
    d: "M46.693 9.807c5.188 4.492 3.426 15.876-3.952 25.647-7.377 9.77-17.61 14.115-22.924 9.664-5.188-4.492-3.426-15.876 3.952-25.647 7.378-9.77 17.61-14.115 22.924-9.664Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aX)",
    d: "M46.741 9.933c5.135 4.358 3.426 15.875-3.951 25.645-7.377 9.77-17.609 14.113-22.796 9.62-5.135-4.357-3.426-15.873 3.95-25.643 7.378-9.77 17.61-14.114 22.797-9.622Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aY)",
    d: "M46.747 9.932c5.136 4.36 3.427 15.88-4.005 25.517-7.379 9.773-17.666 13.983-22.802 9.625-5.136-4.36-3.426-15.88 4.006-25.517C31.324 9.784 41.61 5.573 46.747 9.931Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aZ)",
    d: "M46.62 9.977c5.135 4.359 3.373 15.744-4.006 25.517-7.431 9.638-17.54 13.94-22.675 9.582-5.136-4.36-3.374-15.745 4.005-25.517 7.431-9.638 17.54-13.94 22.675-9.582Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ba)",
    d: "M46.624 9.977c5.136 4.36 3.374 15.745-3.933 25.342-7.431 9.638-17.54 13.94-22.676 9.582-5.136-4.36-3.373-15.745 3.933-25.341 7.306-9.597 17.54-13.941 22.676-9.583Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bb)",
    d: "M46.624 9.977c5.136 4.36 3.374 15.745-3.933 25.342-7.306 9.596-17.414 13.899-22.676 9.582-5.136-4.36-3.373-15.745 3.933-25.341 7.306-9.597 17.414-13.9 22.676-9.583Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD73F",
    d: "M46.542 10.152c5.136 4.358 3.373 15.743-3.932 25.338-7.306 9.596-17.413 13.898-22.549 9.54-5.135-4.36-3.373-15.744 3.933-25.34 7.305-9.594 17.413-13.897 22.548-9.538Z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#A25A00",
    style: {
      mixBlendMode: "screen"
    }
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "m21.48 18.926 23.991 16.486s.338-.562.533-.777L22.013 18.149s-.39.43-.532.777ZM18.48 22.512c-3.065 5.096-4.85 10.215-5.193 14.7L30.12 48.752c4.15-1.994 8.5-5.26 12.326-9.858l-24.02-16.514.053.133ZM28.355 11.645a53.691 53.691 0 0 0-4.48 4.653l23.907 16.444c1.088-1.865 2.124-3.863 2.84-5.604l-22.338-15.32.072-.173ZM35.37 6.773c-1.756.889-3.407 2.043-5.13 3.37l21.59 14.828a33.49 33.49 0 0 0 1.515-5.762l-18.1-12.395.125-.041Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bc)",
    d: "M55.306 21.856c2.94 2.426 3.462 6.722 1.277 9.557-2.185 2.835-6.376 3.074-9.315.648-2.94-2.427-3.463-6.723-1.278-9.557 2.185-2.835 6.376-3.074 9.316-.648Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 12.607,
    x2: 46.833,
    y1: 49.94,
    y2: 8.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD9226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#EFBE3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EDB938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#DE972C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#D68225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D37B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#DA8F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#EBC017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#F6DE11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FBEA10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FBEA10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFCA42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 10.633,
    x2: 44.919,
    y1: 48.434,
    y2: 7.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FAAD29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#DA901C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B8720F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A35F07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#9C5905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#A46714"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#CBA657"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E7D489"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F8F1A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFFCB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFFCB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D69F49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 29.592,
    x2: 6.945,
    y1: 35.989,
    y2: -3.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 29.59,
    x2: 6.94,
    y1: 35.998,
    y2: -3.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 29.589,
    x2: 6.944,
    y1: 35.986,
    y2: -3.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 29.59,
    x2: 6.944,
    y1: 35.992,
    y2: -3.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 29.59,
    x2: 6.944,
    y1: 35.992,
    y2: -3.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 29.585,
    x2: 6.936,
    y1: 35.989,
    y2: -3.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 29.595,
    x2: 6.947,
    y1: 35.993,
    y2: -3.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 29.595,
    x2: 6.951,
    y1: 35.991,
    y2: -3.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 29.592,
    x2: 6.945,
    y1: 35.989,
    y2: -3.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 29.59,
    x2: 6.945,
    y1: 35.991,
    y2: -3.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 29.598,
    x2: 6.954,
    y1: 35.989,
    y2: -3.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 29.59,
    x2: 6.941,
    y1: 35.992,
    y2: -3.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 29.588,
    x2: 6.941,
    y1: 35.994,
    y2: -3.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 29.595,
    x2: 6.95,
    y1: 35.992,
    y2: -3.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 29.59,
    x2: 6.944,
    y1: 35.991,
    y2: -3.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 29.592,
    x2: 6.946,
    y1: 35.988,
    y2: -3.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 29.593,
    x2: 6.944,
    y1: 35.996,
    y2: -3.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 29.589,
    x2: 7.075,
    y1: 35.986,
    y2: -3.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 29.591,
    x2: 7.079,
    y1: 35.988,
    y2: -3.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 29.594,
    x2: 7.079,
    y1: 35.993,
    y2: -3.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 29.589,
    x2: 7.077,
    y1: 35.984,
    y2: -3.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 29.59,
    x2: 7.077,
    y1: 35.99,
    y2: -3.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 29.59,
    x2: 7.075,
    y1: 35.992,
    y2: -3.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 29.587,
    x2: 7.074,
    y1: 35.987,
    y2: -3.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 29.592,
    x2: 7.078,
    y1: 35.989,
    y2: -3.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 29.589,
    x2: 7.074,
    y1: 35.991,
    y2: -3.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 29.592,
    x2: 7.079,
    y1: 35.988,
    y2: -3.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 29.649,
    x2: 7.083,
    y1: 35.645,
    y2: -2.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEEB72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FEDC62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED75D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 29.737,
    x2: 7.11,
    y1: 35.527,
    y2: -1.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEF075"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FDEA6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FDDA60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD45A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 29.794,
    x2: 7.103,
    y1: 35.184,
    y2: -0.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEEF73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FDE96D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FCD95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD258"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 29.851,
    x2: 7.111,
    y1: 34.842,
    y2: 0.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEEE71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FDE86C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FBD85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCF55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 29.944,
    x2: 7.258,
    y1: 34.726,
    y2: 1.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEED6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FDE76A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FBD75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FACD53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 30,
    x2: 7.14,
    y1: 34.383,
    y2: 2.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEEC6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FDE667"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FAD65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9CA50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 29.966,
    x2: 7.299,
    y1: 34.158,
    y2: 3.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEEB6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FDE565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FAD559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8C84E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 30.15,
    x2: 7.3,
    y1: 33.917,
    y2: 3.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEEA68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FCE463"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FAD458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C54C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 30.118,
    x2: 7.582,
    y1: 33.69,
    y2: 4.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEE966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FCE361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F9D355"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C349"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 30.17,
    x2: 7.586,
    y1: 33.351,
    y2: 5.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEE863"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FCE25F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F9D254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C047"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 30.255,
    x2: 7.739,
    y1: 33.225,
    y2: 6.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEE761"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FCE15D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F8D152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4BE44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 30.224,
    x2: 7.888,
    y1: 33.005,
    y2: 6.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEE65F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FCE05B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F8D050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3BB42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: 30.405,
    x2: 8.01,
    y1: 32.767,
    y2: 7.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFE55D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FDDF59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F8CF4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2B940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 30.372,
    x2: 8.186,
    y1: 32.54,
    y2: 8.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFE35A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FDDD56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F8CD4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B73D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    x1: 30.463,
    x2: 8.336,
    y1: 32.421,
    y2: 8.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFE258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FDDC54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F8CC4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B43B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    x1: 30.52,
    x2: 8.474,
    y1: 32.077,
    y2: 9.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFE156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FDDB52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F7CB48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFB238"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: 30.61,
    x2: 8.628,
    y1: 31.958,
    y2: 10.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFE053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FDDA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F7CA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#EEB137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAF36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    x1: 30.573,
    x2: 8.787,
    y1: 31.738,
    y2: 10.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFDF51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FDD94D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F7C944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EEB034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDAD33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    x1: 30.666,
    x2: 9.053,
    y1: 31.623,
    y2: 11.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFDE4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FCD84B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F7C842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EDAF33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECAA31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    x1: 30.637,
    x2: 9.23,
    y1: 31.393,
    y2: 11.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFDD4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FCD749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F7C741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#EDAE32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBA82F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    x1: 30.818,
    x2: 9.484,
    y1: 31.154,
    y2: 12.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFDC4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FCD647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F6C63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#EDAD30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAA52C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    x1: 30.908,
    x2: 9.651,
    y1: 31.035,
    y2: 12.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFDB48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FCD545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F6C53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#ECAC2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9A32A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    x1: 30.874,
    x2: 9.929,
    y1: 30.811,
    y2: 13.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFDA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F6C43A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#ECAB2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8A027"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 30.965,
    x2: 10.204,
    y1: 30.692,
    y2: 13.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD341"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F6C338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#EBAA2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E79E25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 31.049,
    x2: 10.242,
    y1: 30.567,
    y2: 14.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD841"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD23E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F6C236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E69B22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 31.016,
    x2: 10.526,
    y1: 30.348,
    y2: 14.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 31.016,
    x2: 10.524,
    y1: 30.348,
    y2: 14.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 31.016,
    x2: 10.524,
    y1: 30.348,
    y2: 14.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: 31.016,
    x2: 10.524,
    y1: 30.348,
    y2: 14.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 31.016,
    x2: 10.653,
    y1: 30.348,
    y2: 14.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 31.021,
    x2: 10.662,
    y1: 30.342,
    y2: 14.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 31.023,
    x2: 10.662,
    y1: 30.346,
    y2: 14.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: 31.018,
    x2: 10.655,
    y1: 30.351,
    y2: 14.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 31.018,
    x2: 10.655,
    y1: 30.351,
    y2: 14.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: 31.013,
    x2: 10.649,
    y1: 30.345,
    y2: 14.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: 31.015,
    x2: 10.654,
    y1: 30.342,
    y2: 14.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: 31.022,
    x2: 10.66,
    y1: 30.348,
    y2: 14.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x1: 30.893,
    x2: 10.659,
    y1: 30.24,
    y2: 14.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: 30.889,
    x2: 10.655,
    y1: 30.245,
    y2: 14.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: 30.894,
    x2: 10.664,
    y1: 30.24,
    y2: 14.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    x1: 30.894,
    x2: 10.664,
    y1: 30.24,
    y2: 14.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    x1: 30.894,
    x2: 10.793,
    y1: 30.24,
    y2: 14.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    x1: 30.897,
    x2: 10.793,
    y1: 30.243,
    y2: 14.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    x1: 30.897,
    x2: 10.793,
    y1: 30.243,
    y2: 14.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    x1: 30.888,
    x2: 10.787,
    y1: 30.239,
    y2: 14.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aw",
    x1: 30.888,
    x2: 10.785,
    y1: 30.24,
    y2: 14.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ax",
    x1: 30.888,
    x2: 10.785,
    y1: 30.24,
    y2: 14.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay",
    x1: 30.891,
    x2: 10.79,
    y1: 30.237,
    y2: 14.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    x1: 30.893,
    x2: 10.787,
    y1: 30.24,
    y2: 14.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aA",
    x1: 30.771,
    x2: 10.797,
    y1: 30.132,
    y2: 14.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aB",
    x1: 30.766,
    x2: 10.792,
    y1: 30.137,
    y2: 14.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aC",
    x1: 30.766,
    x2: 10.792,
    y1: 30.137,
    y2: 14.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aD",
    x1: 29.779,
    x2: 10.131,
    y1: 29.946,
    y2: 14.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E69B21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aE",
    x1: 30.7,
    x2: 11.395,
    y1: 30.119,
    y2: 14.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E79E22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aF",
    x1: 32.998,
    x2: 13.934,
    y1: 32.07,
    y2: 15.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8A024"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aG",
    x1: 37.05,
    x2: 18.361,
    y1: 34.247,
    y2: 17.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9A325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aH",
    x1: 42.649,
    x2: 24.356,
    y1: 36.232,
    y2: 19.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAA526"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aI",
    x1: 49.316,
    x2: 31.32,
    y1: 39.35,
    y2: 21.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#EBA827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBA727"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aJ",
    x1: 56.865,
    x2: 39.188,
    y1: 43.657,
    y2: 25.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECAA28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aK",
    x1: 27.563,
    x2: 9.96,
    y1: 31.052,
    y2: 12.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDAC2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aL",
    x1: 38.405,
    x2: 21.275,
    y1: 36.053,
    y2: 17.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAE2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aM",
    x1: 49.77,
    x2: 32.937,
    y1: 40.899,
    y2: 21.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFB12C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aN",
    x1: 29.666,
    x2: 12.996,
    y1: 32.17,
    y2: 11.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B32D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aO",
    x1: 42.596,
    x2: 26.368,
    y1: 38.473,
    y2: 17.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B62E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aP",
    x1: 28.078,
    x2: 12.069,
    y1: 32.58,
    y2: 11.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2B82F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aQ",
    x1: 41.544,
    x2: 26.023,
    y1: 38.803,
    y2: 16.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3BA31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aR",
    x1: 31.798,
    x2: 16.56,
    y1: 34.643,
    y2: 12.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4BD32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aS",
    x1: 44.621,
    x2: 29.843,
    y1: 40.739,
    y2: 17.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F6C134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5BF33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aT",
    x1: 55.591,
    x2: 41.297,
    y1: 45.76,
    y2: 22.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aU",
    x1: 48.828,
    x2: 34.9,
    y1: 43.499,
    y2: 19.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C435"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aV",
    x1: 44.292,
    x2: 30.769,
    y1: 41.64,
    y2: 16.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8C637"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aW",
    x1: 41.466,
    x2: 28.37,
    y1: 40.931,
    y2: 15.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9C938"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aX",
    x1: 39.882,
    x2: 27.25,
    y1: 40.409,
    y2: 14.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FACB39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aY",
    x1: 39.15,
    x2: 26.997,
    y1: 40.69,
    y2: 13.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FCD13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBCD3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aZ",
    x1: 39.29,
    x2: 27.653,
    y1: 40.987,
    y2: 13.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FCD13B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD03B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ba",
    x1: 39.4,
    x2: 28.356,
    y1: 41.517,
    y2: 13.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb",
    x1: 39.631,
    x2: 29.144,
    y1: 41.897,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFD73F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED53E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bc",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.96422 -5.0983 5.42752 4.2202 39.22 21.615)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinBig);
export default __webpack_public_path__ + "static/media/coin-big.cd3ffe2e2925ec98c78a4b928e2334fe.svg";
export { ForwardRef as ReactComponent };